import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";

const MegaHeaderModuleAsyncComponent = AsyncComponent(async () => import('./mega-header.module' /* webpackChunkName: "mega-header-module" */ ));

export const MegaHeaderModuleAsync = ({isSmallView, ...props}) => {
  return <MegaHeaderModuleAsyncComponent {...props}/>

}
